// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-lock-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: end;
    color: #005499;
    border: 1px solid #b3ddff;
    border-radius: 16px;
    background: linear-gradient(0deg,#b3ddff,#b3ddff),linear-gradient(0deg,#e5f4ff,#e5f4ff);
    padding: 16px;
    font-size: 16px;
    gap: 10px;
    margin-top: 20px;
    margin-bottom: 50px;
    width: 100%;
}

.profile-lock-wrapper img {
    width: 30px;
    height: 39px;
}

.lock-for-edit {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/components/common/ProfileEditLockInfo.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,uFAAuF;IACvF,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB","sourcesContent":[".profile-lock-wrapper {\n    display: flex;\n    justify-content: flex-start;\n    align-items: end;\n    color: #005499;\n    border: 1px solid #b3ddff;\n    border-radius: 16px;\n    background: linear-gradient(0deg,#b3ddff,#b3ddff),linear-gradient(0deg,#e5f4ff,#e5f4ff);\n    padding: 16px;\n    font-size: 16px;\n    gap: 10px;\n    margin-top: 20px;\n    margin-bottom: 50px;\n    width: 100%;\n}\n\n.profile-lock-wrapper img {\n    width: 30px;\n    height: 39px;\n}\n\n.lock-for-edit {\n    opacity: 0.5;\n    pointer-events: none;\n    cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
